var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "clickoutside",
          rawName: "v-clickoutside",
          value: _vm.clickoutsideHandle,
          expression: "clickoutsideHandle",
        },
      ],
      staticClass: "table-wrap-select",
    },
    [
      _c("div", { staticClass: "table-wrap-select-title" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("i", { staticClass: "el-icon-setting" }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "table-wrap-select-title-p",
            on: { click: _vm.openHandle },
          },
          [_vm._v("设置查看项")]
        ),
      ]),
      _vm._v(" "),
      _vm.open
        ? _c(
            "div",
            { staticClass: "table-wrap-select-ul" },
            [
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.selectUIChange },
                  model: {
                    value: _vm.checkedSelectProps,
                    callback: function ($$v) {
                      _vm.checkedSelectProps = $$v
                    },
                    expression: "checkedSelectProps",
                  },
                },
                _vm._l(_vm.defaultColumn, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "table-wrap-select-ul-li" },
                    [
                      _c(
                        "el-checkbox",
                        { key: index, attrs: { label: item.name } },
                        [_vm._v(_vm._s(item.name))]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", { staticClass: "iconfont eicon-szkc-shezhi" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }